var React = require('react');

function NavIconsApiTokens (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m8.47 10-1.16 2.6v1.06h.79v-.89l.08-.17h1.3l.09.18v.88h.78v-1l-1.18-2.66zm0 1.91.35-.91.38.87zm4.08-1.91h-1.71v3.7h.78v-1.46h.93q1 0 1-.87v-.54q-.04-.83-1-.83zm.18 1.31c0 .18 0 .24-.25.24h-.86v-.85h.86c.23 0 .25.06.25.22zm3 1.64v-2.25h.89v-.7h-2.62v.74h.89v2.21h-.89v.75h2.68v-.75z","key":0}),React.createElement("path",{"d":"m12 21.91a9.91 9.91 0 1 1 9.91-9.91 9.91 9.91 0 0 1 -9.91 9.91zm0-18.76a8.85 8.85 0 1 0 8.85 8.85 8.86 8.86 0 0 0 -8.85-8.85z","key":1}),React.createElement("path",{"d":"m5.07 12h-1a7.9 7.9 0 0 0 7.93 7.89v-1a6.94 6.94 0 0 1 -6.93-6.89z","key":2}),React.createElement("path",{"d":"m12 5.07a6.94 6.94 0 0 1 6.93 6.93h1a7.9 7.9 0 0 0 -7.93-7.89v1z","key":3})]);
}

NavIconsApiTokens.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsApiTokens;

NavIconsApiTokens.default = NavIconsApiTokens;
